module.exports = __webpack_public_path__ + "img/3.f3d86149.jpg";